import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Burger.scss';

function Burger({ open, setOpen, ...props }) {
  return (
    <button
      id="_burger_"
      className={classnames({
        open: open
      })}
      onClick={() => setOpen(!open)}
    >
      <span />
      <span />
      <span />
    </button>
  );
}

Burger.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
};

export default Burger;
